<template>
  <div class="preview-form">
    <i-button @click="print=true">打印</i-button>
    <div class="padding-top-20"></div>
    <div class="print-area">
      <v-print :doPrint.sync="print">
        <component :is="current" :guarantorId="$route.params.guarantorId" v-if="ready" />
      </v-print>
    </div>
    <div id="print"></div>
  </div>
</template>

<script>
import PreviewDefault from './Preview_default.vue'
import PreviewHeNan from './Preview_henan.vue'
import vPrint from 'syl-vue-printer'
export default {
  name: 'preview-form',
  props: {
  },
  components: {
    PreviewDefault,
    PreviewHeNan,
    vPrint
  },
  data () {
    return {
      loading: false,
      ready: false,
      current: 'PreviewDefault',
      print: false
    }
  },
  watch: {
  },
  computed: {
  },
  mounted () {
    if (this.$store.getters.sysConfigs['WELCOME_LAYOUT_NAME']) {
      this.current = `Preview${this.$store.getters.sysConfigs['WELCOME_LAYOUT_NAME']}`
      this.ready = true
    } else {
      this.current = 'PreviewDefault'
      this.ready = true
    }
  },
  activated () {
  },
  deactivated () {
  },
  methods: {
  }
}
</script>

<style lang="less" scoped>
</style>
